import React, { useState, useEffect } from "react";
import { Box, RadioGroup, Stack, Radio, Button, Image } from "@chakra-ui/react";
import SubmitIcon from "../Images/Submit-Icon.svg";
import SubmitIconDark from "../Images/Submit-Icon-Dark.svg";
import Dotsloading from "./DotsLoading";
import { a } from "./appColors";

const MultipleChoiceDisplay = ({
  questionGuid,
  options = [],
  existingValue = "",
  onSubmitAnswer,
  onAnswerChange,
  loading = false,
  isSaveMode = false,
}) => {
  const [selectedValue, setSelectedValue] = useState(existingValue);
  const [lastSubmittedValue, setLastSubmittedValue] = useState(existingValue);

  // Preloaded answers
  useEffect(() => {
    setSelectedValue(existingValue);
    setLastSubmittedValue(existingValue);
  }, [existingValue]);

  const handleSelectionChange = (value) => {
    setSelectedValue(value);
    if (typeof onAnswerChange === "function") {
      onAnswerChange(value);
    }
  };

  const handleSubmit = async () => {
    if (!selectedValue) {
      alert("Please select an option before submitting!");
      return;
    }

    await onSubmitAnswer(questionGuid, selectedValue, []);
    setLastSubmittedValue(selectedValue);
  };

  const hasChanges = selectedValue !== lastSubmittedValue;

  return (
    <Box mt={4}>
      <RadioGroup value={selectedValue} onChange={handleSelectionChange}>
        <Stack direction="column">
          {options.map((option) => (
            <Radio
              key={option.label}
              value={option.label}
              sx={{
                "&.chakra-radio__control": {
                  borderColor: a.inputBorder,
                  backgroundColor: a.surface,
                },
                "&.chakra-radio__control[data-checked]": {
                  backgroundColor: a.blue,
                  borderColor: a.blue,
                },
                "&.chakra-radio__label": {
                  color: a.text,
                  fontWeight: "400",
                  fontSize: "14px",
                },
              }}
            >
              {`${option.label} ${option.text}`}
            </Radio>
          ))}
        </Stack>
      </RadioGroup>

      <Button 
        flexShrink={0}
        minW="120px"
        px="14px"
        py="8px"
        borderRadius="8px"
        bg={(!hasChanges && isSaveMode) ? a.surfaceSubtle : a.accentSoft}
        color={(!hasChanges && isSaveMode) ? a.textMuted : a.accent}
        fontSize="11px"
        fontWeight="400"
        mt={9}
        onClick={(!hasChanges && isSaveMode) ? null : handleSubmit}
        _hover={(!hasChanges && isSaveMode) ? {} : { border: "1.21px solid", borderColor: a.border, bg: a.surface, color: a.text2 }}
        cursor={(!hasChanges && isSaveMode) ? "not-allowed" : "pointer"}
      >
        {!isSaveMode && <Image src={SubmitIcon} alt="Submit" />}
        {loading ? (isSaveMode ? "Saving ..." : "Submitting ...") : (isSaveMode ? "Save" : "Mark")}
      </Button>
      {loading && <Dotsloading/>}
    </Box>
  );
};

export default MultipleChoiceDisplay;
